// 店舗ページの下部追従CTA。
// 「インラインの応募ボタン」「下部の関連求人」のどちらかが見えている間は追従バーを隠し、
// それ以外の間だけフェード表示する(関連求人の閲覧を邪魔しないため)。
// display切替(hidden)だとtransitionが効かないため、visibility+opacityのクラスをトグルする
export const initShopFloatingCta = () => {
  const inlineCta = document.querySelector('.js-shop-entry-cta')
  const floatingCta = document.querySelector<HTMLElement>('.js-shop-floating-cta')
  if (inlineCta === null || floatingCta === null) return

  // 関連求人セクションは無いページもある(レコメンド0件)ため、あるときだけ監視対象に加える
  const hideTargets = [inlineCta, document.querySelector('.js-shop-recommends')].filter((el): el is Element => el !== null)
  const visibleByTarget = new Map<Element, boolean>()

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => visibleByTarget.set(entry.target, entry.isIntersecting))
    const shouldHide = [...visibleByTarget.values()].some(Boolean)
    floatingCta.classList.toggle('invisible', shouldHide)
    floatingCta.classList.toggle('opacity-0', shouldHide)
  })
  hideTargets.forEach((el) => observer.observe(el))
}
